import { NewDynamicTab } from "../../../components/Page";
import { RuvnlTitle } from "../components";
import { RajasthanDiscomAnalysis } from "./Discom_Analysis";
import { RajasthanDrawal } from "./Drawal";
import { RajasthanTrend } from "./TrendAnalysis";
import { TabSwitcher } from "../Raj_Dashboard";
import { RajasthanDrawalTrend } from "./Drawal_Trend";
import { Rajasthan_Forecast_Surplus } from "./Forecast_Surplus";
import { RuvitalDemand } from "../../../config/DefaultDates";

export function DemoRajDemand() {
  return (
    <NewDynamicTab
      defaultDates={RuvitalDemand}
      header="Demand"
      trendTabs={["Trend Analysis", "Restricted Demand Trend Analysis"]}
      middleComponent={<RuvnlTitle />}
      headerPrefixComponent={<TabSwitcher />}
      tabs={{
        "Discom Load ": <RajasthanDiscomAnalysis />,
        "Trend Analysis": <RajasthanTrend />,
        "Restricted Demand": <RajasthanDrawal />,
        "Restricted Demand Trend Analysis": <RajasthanDrawalTrend />,
        "Surplus/Deficit Analysis": <Rajasthan_Forecast_Surplus />,
      }}
    />
  );
}
